import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar.jsx";
import SocialLinks from "./ui/SocialLinks.jsx";
import ParallaxText from "./ui/ParallaxText.jsx";
import ParticleBackground from "./ui/ParticleBackground.jsx";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <div id="hero" className="relative min-h-screen bg-navy text-white overflow-hidden">
      <Navbar />

      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <ParticleBackground />
        <ParallaxText
          speed={0.2}
          className="absolute top-1/4 -right-40 opacity-5 hidden lg:block"
        >
          <div className="text-[20rem] font-bold text-accent/10 select-none pointer-events-none">
            AWN
          </div>
        </ParallaxText>
      </div>

      {/* Fixed Social Links - Left Side */}
      <SocialLinks position="left" delay={2} />

      {/* Fixed Email - Right Side */}
      <SocialLinks
        position="right"
        email="anthony.roverenjeri@gmail.com"
        delay={2.2}
      />

      {/* Main Content */}
      <div className="relative z-10 min-h-screen flex items-center px-4 sm:px-6 lg:px-12 pt-24 sm:pt-28 lg:pt-0">
        <div className="max-w-6xl mx-auto w-full">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="max-w-none"
          >
            {/* Introduction */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="mb-4 sm:mb-5"
            >
              <p className="text-accent font-mono text-sm sm:text-base">
                {t('hero.greeting')}
              </p>
            </motion.div>

            {/* Name */}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-semibold text-lighterSlate leading-[1.1] mb-1 sm:mb-2 tracking-tight"
            >
              {t('hero.name')}
            </motion.h1>

            {/* Subtitle */}
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium text-accent mb-6 sm:mb-8"
            >
              {t('hero.tagline')}
            </motion.h2>

            {/* Description */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="max-w-lg sm:max-w-xl mb-10 sm:mb-12"
            >
              <p className="text-base sm:text-lg lg:text-xl text-slate leading-relaxed">
                {t('hero.description')}
              </p>
            </motion.div>

            {/* CTA Button */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.5 }}
            >
              <motion.a
                href="mailto:anthony.roverenjeri@gmail.com"
                className="inline-block px-6 py-4 sm:px-7 sm:py-5 border border-accent text-accent rounded font-mono text-sm hover:bg-accent/10 transition-all duration-300 cursor-pointer"
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0 10px 30px rgba(59, 130, 246, 0.15)",
                }}
                whileTap={{ scale: 0.98 }}
                transition={{ duration: 0.2 }}
              >
                {t('hero.cta')}
              </motion.a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
